import ctrlWorkflow from '@/modules/workflow/ctrl-workflow/store';
import ctrlProcessos from '@/modules/workflow/ctrl-processos/store';
import ctrlTarefas from '@/modules/workflow/ctrl-tarefas/store'
import ctrlProvedores from '@/modules/workflow/ctrl-provedores/store';
import ctrlFormularios from '@/modules/workflow/ctrl-formularios/store';
import tickets from '@/modules/workflow/tickets/store';
import fichaTecnicaWorkflow from '@/modules/workflow/ficha-tecnica-workflow/store';
import filasTarefas from '@/modules/workflow/filas-tarefas/store';
import ctrlWorkflowRecuperacao from '@/modules/workflow/ctrl-workflow-recuperacao/store';
import ctrlTarefasMobilidades from '@/modules/workflow/tarefas-mobilidades/store';
import ctrlTratativas from '@/modules/workflow/ctrl-tratativas/store';
import pcoEmailsQueue from '@/modules/workflow/pco-emails-queue/store';
import pcoWorkflowTemp from '@/modules/workflow/pco-workflow-temp/store';
import gestaoEmailsAutomaticos from '@/modules/workflow/gestao-emails-automaticos/store';
import ctrlDesignacao from '@/modules/workflow/ctrl-designacao/store';
import ctrlProvedoresMulta from '@/modules/workflow/ctrl-provedores-multa/store';
import ctrlDisponibilidade from '@/modules/workflow/ctrl-disponibilidade/store';
import ctrlAnaliticosProvedor from '@/modules/workflow/ctrl-analiticos-provedor/store';
import ctrlTipoSolicitacao from '@/modules/workflow/ctrl-tipo-solicitacao/store';
import ctrlTipoServico from '@/modules/workflow/ctrl-tipo-servico/store';
import backlog from '@/modules/workflow/backlog/store';
import workflowFormsStore from '@/modules/workflow/forms/store';
import ctrlRegionais from '@/modules/workflow/ctrl-regionais/store';
import formularios from '@/modules/workflow/forms/formularios/store';
import tiposStatus from '@/modules/workflow/forms/formularios/store/tipos-status';
import ctrlEstados from '@/modules/workflow/ctrl-tarefas/store/lookups/ctrl-estados';
import tiposTarefas from '@/modules/workflow/tarefas-mobilidades/store/lookups/tipos-tarefas';
import ctrlConclusoes from '@/modules/workflow/tarefas-mobilidades/store/lookups/ctrl-conclusoes';
import ctrlTratativasOpcoes from '@/modules/workflow/tarefas-mobilidades/store/lookups/ctrl-tratativas-opcoes';
import ctrlMetodos from '@/modules/workflow/tarefas-mobilidades/store/lookups/ctrl-metodos';
import automacao from '@/modules/workflow/ficha-tecnica-workflow/store/automacao';
import circuitos from '@/modules/workflow/ficha-tecnica-workflow/store/circuitos';
import modos from '@/modules/workflow/ficha-tecnica-workflow/store/modos';
import ctrlEstadosWf from '@/modules/workflow/ctrl-estados/store';
import ctrlPrazosContratuais from '@/modules/workflow/ctrl-prazos-contratuais/store';
import ctrlStatus from '@/modules/workflow/ctrl-status/store';
import pesquisa from '@/modules/workflow/pesquisa/store';
import ctrlTecnicos from '@/modules/workflow/ctrl-tecnicos/store';
import pcoNotificacoes from '@/modules/workflow/pco-notificacoes/store';

const store = {
  ctrlWorkflow,
  ctrlProcessos,
  ctrlTarefas,
  ctrlProvedores,
  ctrlFormularios,
  tickets,
  fichaTecnicaWorkflow,
  filasTarefas,
  ctrlWorkflowRecuperacao,
  ctrlTarefasMobilidades,
  ctrlTratativas,
  ctrlDesignacao,
  ctrlProvedoresMulta,
  ctrlDisponibilidade,
  ctrlAnaliticosProvedor,
  ctrlTipoSolicitacao,
  ctrlTipoServico,
  pcoEmailsQueue,
  pcoWorkflowTemp,
  gestaoEmailsAutomaticos,
  backlog,
  formularios,
  tiposStatus,
  ctrlEstados,
  tiposTarefas,
  ctrlConclusoes,
  ctrlTratativasOpcoes,
  ctrlMetodos,
  automacao,
  circuitos,
  modos,
  ...workflowFormsStore,
  ctrlEstadosWf,
  ctrlPrazosContratuais,
  ctrlRegionais,
  pesquisa,
  ctrlStatus,
  ctrlTecnicos,
  pcoNotificacoes,
}

export default store
